module.exports = __webpack_public_path__ + "assets/img/btn-view-deb04829.png";